// modules
import { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class DocumentTitle extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
  }

  static defaultProps = {
    title: '',
  }

  componentWillMount() {
    const { title } = this.props;
    if (typeof document === 'undefined') return;
    Object.assign(document, { title });
  }

  componentWillReceiveProps({ title }) {
    if (typeof document === 'undefined') return;
    if (title !== document.title) {
      Object.assign(document, { title });
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentTitle/index.jsx